import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders,
  HttpResponse, // ⬅ add this
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, tap, finalize } from 'rxjs/operators';
import { ErrorDialogService } from '../error-dialog/errordialog.service';
import * as g from 'src/app/globals';
import { CookieService } from 'ngx-cookie-service';
import { ResponseObject } from '@app/models/ResponseData';
import { LoadingService } from '@app/services/loading.service';

// ⬇️ Sentry
// import * as Sentry from '@sentry/angular';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    public errorDialogService: ErrorDialogService,
    public cookieService: CookieService,
    private loadingService: LoadingService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Start tracking request in your loader
    this.loadingService.addRequest(request.url);

    // --- Sentry: start span + breadcrumb ------------------------------------
    // const txn = Sentry.getCurrentHub().getScope()?.getTransaction();
    // console.log('request.url', request.url);
    // const span = txn?.startChild({
    //   op: 'http.client',
    //   description: `${request.method} ${request.urlWithParams}`,
    //   data: {
    //     url: request.url,
    //     method: request.method,
    //   },
    // });

    // Sentry.addBreadcrumb({
    //   category: 'http',
    //   type: 'http',
    //   level: 'info',
    //   message: `HTTP ${request.method} → ${request.url}`,
    //   data: { method: request.method, url: request.url },
    // });
    // ------------------------------------------------------------------------

    // Auth + app headers (keep your existing behavior)
    let authReq = request;
    if (
      g.getToken() != null &&
      g.language != null &&
      g.app != null &&
      request.url.includes(g.baseUrl)
    ) {
      let newHeaders = new HttpHeaders()
        .append('Authorization', 'Bearer ' + g.getToken())
        .append('Language', g.language)
        .append('App', g.app);

      if (!newHeaders.has('Content-Type')) {
        if (!(request.body instanceof FormData)) {
          newHeaders = newHeaders.append('Content-Type', 'application/json');
        }
      }

      authReq = request.clone({ headers: newHeaders });
    }

    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => event),

      tap((response) => {
        // Your existing domain-specific error surface
        if (response instanceof ResponseObject && response.Success === false) {
          const data = {
            reason: response.Errors[0],
            status: response.Success ? 'success' : 'failed',
            error: response.Errors[0],
            httpResponse: response,
            request,
          };
          this.errorDialogService.openDialog(data);
        }

        // // --- Sentry: finish span on successful HTTP response ----------------
        // if (response instanceof HttpResponse) {
        //   span?.setHttpStatus(response.status);
        //   span?.finish();
        // }
        // // --------------------------------------------------------------------
      }),

      catchError((error: HttpErrorResponse) => {
        // If it’s not your API, just bubble up (keep your behavior)
        // if (!error.url?.includes(g.baseUrl)) {
        //   // Sentry: still finish span to avoid leaks
        //   span?.setStatus('cancelled');
        //   span?.finish();
        //   return throwError(() => error);
        // }

        // Your existing UI error handling
        let data: any = {};
        const responseKeys = Object.keys(error.error ?? {});
        if (responseKeys.includes('Success') && error.error.Success === false) {
          try {
            const errors = (error.error.Errors as string[]) ?? [];
            errors.forEach((err) => {
              data = {
                message: err,
                success: false,
                error: err,
                httpResponse: error.error,
                request,
              };
              this.errorDialogService.openDialog(data);
            });
          } catch {
            data = {
              message: 'error',
              success: false,
              error: 'Failed',
              httpResponse: error.error,
              request,
            };
            this.errorDialogService.openDialog(data);
          }
        } else {
          data = {
            reason: error.message,
            status: error.name,
            error: error.error,
            httpResponse: error,
            request,
          };
          this.errorDialogService.openDialog(data);
        }

        // --- Sentry: capture the error (sanitize!) --------------------------
        // Sentry.captureException(error, {
        //   tags: {
        //     http_method: request.method,
        //     http_status: String(error.status),
        //   },
        //   extra: {
        //     url: request.url,
        //     // never send PII; do not include request body; truncate response
        //     responseSnippet:
        //       typeof error.error === 'string'
        //         ? error.error.slice(0, 500)
        //         : JSON.stringify(error.error ?? {}, null, 2).slice(0, 500),
        //   },
        //   level: 'error',
        // });

        // span?.setHttpStatus(error.status);
        // span?.setStatus('internal_error');
        // span?.finish();
        // --------------------------------------------------------------------

        return throwError(() => error);
      }),

      finalize(() => {
        // Stop tracking the request in your loader
        this.loadingService.removeRequest(request.url);

        // Safety: if not finished above, finish the span here
        // (should be a no-op if already finished)
        // span?.finish();
      })
    );
  }
}
